<template>
  <div>
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Posicionamento de imagens</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" md="3">
              <v-select
                v-model="formImagePosition"
                :items="positionOptions"
                label="Posição da imagem no formulário"
                outlined
                hide-details
                placeholder="Selecione uma posição"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'HotsiteConfigurationPositions',
  data: () => ({
    positionOptions: [
      { text: 'Direita', value: 'RIGHT' },
      { text: 'Esquerda', value: 'LEFT' },
    ],
  }),
  computed: {
    ...mapGetters('hotsiteConfiguration', ['positionsWithDefaults']),
    formImagePosition: {
      get() {
        return this.positionsWithDefaults?.formImage || null
      },
      set(value) {
        this.updatePositions({
          formImage: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('hotsiteConfiguration', ['updatePositions']),
  },
}
</script>
